import { createFileRoute } from '@tanstack/react-router'
import { Wallet } from '@/components/walletNew/Wallet'

export const Route = createFileRoute('/_mainLayout/wallet/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Wallet />
}